export default __webpack_public_path__ + "static/licence-NSW-1490c4cc5211d745ecffa4ac84505d64.svg";